import { render, staticRenderFns } from "./VariantItem.vue?vue&type=template&id=d49779c6"
import script from "./VariantItem.vue?vue&type=script&lang=js"
export * from "./VariantItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports